import { Translations } from './en'

export const pl: Translations = {
  // Navbar
  nav: {
    portfolio: 'Portfolio',
    about: 'O nas',
    contact: 'Kontakt',
    bookCall: 'Umów rozmowę',
  },

  // Hero
  hero: {
    badge: 'Projektowanie stron z AI',
    title: 'Tworzymy strony, które',
    titleHighlight: 'zachwycają klientów.',
    subtitle:
      'Quick Designs łączy najnowocześniejszą technologię AI z kreatywną ekspertyzą, tworząc oszałamiające, przyciągające wzrok strony, które robią wrażenie na odwiedzających i zamieniają ich w klientów.',
    cta: 'Umów rozmowę',
    ctaSecondary: 'Zobacz nasze prace',
  },

  // Portfolio
  portfolio: {
    title: 'Wybrane projekty',
    subtitle:
      'Projekty wzmocnione AI, stworzone by zachwycać i konwertować. Każdy projekt łączy inteligentne narzędzia projektowe z ludzką kreatywnością dla maksymalnego efektu.',
    cta: 'Rozpocznij projekt',
    viewCase: 'Zobacz case study',
    projects: {
      fitness: { title: 'Studio Fitness', category: 'Zdrowie i Fitness' },
      beauty: { title: 'Studio Urody', category: 'Uroda i Wellness' },
    },
  },

  // About
  about: {
    title: 'Studio Projektowe z AI',
    description1:
      'Quick Designs wykorzystuje moc sztucznej inteligencji do tworzenia stron, które naprawdę się wyróżniają. Nasze narzędzia AI analizują trendy projektowe, optymalizują układy i generują oszałamiające wizualizacje, które natychmiast przyciągają uwagę.',
    description2:
      'Wierzymy, że świetny design powinien być dostępny dla każdej firmy. Łącząc możliwości AI z ludzką kreatywnością, dostarczamy premium, przyciągające wzrok strony szybciej i bardziej przystępnie cenowo niż tradycyjne agencje — bez kompromisów w jakości.',
    description3:
      'Niezależnie od tego, czy potrzebujesz odważnej strony docelowej, która zatrzymuje scrollujących, czy kompletnej obecności marki, która pozostawia trwałe wrażenie, nasz workflow wzmocniony AI zapewnia, że Twoja strona wygląda wyjątkowo i działa znakomicie.',
    stats: {
      satisfaction: 'Zadowolenia klientów',
      response: 'Czas odpowiedzi',
      support: 'Wsparcie dostępne',
      revision: 'Nielimitowane poprawki',
    },
    features: {
      fast: {
        title: 'Szybkość z AI',
        description:
          'Nasze narzędzia AI przyspieszają proces projektowania, dostarczając oszałamiające strony w rekordowym czasie bez poświęcania jakości czy kreatywności.',
      },
      secure: {
        title: 'Inteligentne i bezpieczne',
        description:
          'Kod zoptymalizowany przez AI, który stosuje najlepsze praktyki, zapewniając szybkość, bezpieczeństwo i wysokie pozycje w wyszukiwarkach.',
      },
      userCentric: {
        title: 'Projekty, które robią wrażenie',
        description:
          'Układy i wizualizacje wspierane przez AI, stworzone by przyciągać wzrok, angażować odwiedzających i zamieniać przeglądających w lojalnych klientów.',
      },
    },
  },

  // Contact
  contact: {
    title: 'Stwórzmy coś niesamowitego',
    subtitle:
      'Gotowy na stronę z AI, która robi wrażenie? Umów rozmowę, aby omówić swoją wizję.',
    info: {
      title: 'Informacje kontaktowe',
    },
    form: {
      title: 'Wyślij wiadomość',
      name: 'Imię',
      namePlaceholder: 'Jan Kowalski',
      email: 'Email',
      emailPlaceholder: 'jan@example.com',
      message: 'Wiadomość',
      messagePlaceholder: 'Opowiedz nam o swoim projekcie...',
      submit: 'Wyślij wiadomość',
      submitting: 'Wysyłanie...',
      success: {
        title: 'Wiadomość wysłana!',
        subtitle: 'Odpowiemy w ciągu 24 godzin.',
        another: 'Wyślij kolejną wiadomość',
      },
      error: 'Coś poszło nie tak. Spróbuj ponownie.',
    },
    booking: {
      title: 'Umów rozmowę odkrywczą',
    },
  },

  // Footer
  footer: {
    description:
      'Projektowanie stron z AI, które robi wrażenie. Łączymy sztuczną inteligencję z kreatywną ekspertyzą, budując oszałamiające strony, które zachwycają Twoją publiczność.',
    services: {
      title: 'Usługi',
      items: ['Projektowanie z AI', 'Rozwój', 'E-commerce', 'Utrzymanie'],
    },
    company: {
      title: 'Firma',
      items: [
        'O nas',
        'Portfolio',
        'Kariera',
        'Kontakt',
        'Polityka prywatności',
      ],
    },
    copyright: '© 2026 Quick Designs. Wszelkie prawa zastrzeżone.',
    madeWith: 'Stworzone z',
    location: 'w Polsce',
  },

  // Privacy Policy
  privacy: {
    title: 'Polityka Prywatności',
    lastUpdated: 'Ostatnia aktualizacja',
    sections: {
      intro: {
        title: 'Wprowadzenie',
        content:
          'Quick Designs („my", „nas" lub „nasz") zobowiązuje się do ochrony Twojej prywatności. Niniejsza Polityka Prywatności wyjaśnia, w jaki sposób zbieramy, wykorzystujemy, ujawniamy i chronimy Twoje informacje podczas odwiedzania naszej strony internetowej lub korzystania z naszych usług tworzenia stron internetowych.',
      },
      collect: {
        title: 'Informacje, które zbieramy',
        content: 'Możemy zbierać informacje o Tobie na różne sposoby, w tym:',
        items: [
          'Dane osobowe: Imię i nazwisko, adres e-mail, numer telefonu oraz informacje biznesowe podane podczas kontaktu z nami lub zamawiania naszych usług.',
          'Informacje o projekcie: Szczegóły dotyczące Twojej firmy, materiały brandingowe, treści i wymagania udostępniane podczas współpracy projektowej.',
          'Dane użytkowania: Informacje o tym, jak korzystasz z naszej strony, w tym adres IP, typ przeglądarki, odwiedzone strony i czas spędzony na stronach.',
          'Dane komunikacyjne: Zapisy korespondencji podczas kontaktu z nami przez e-mail, formularze kontaktowe lub narzędzia do planowania.',
        ],
      },
      use: {
        title: 'Jak wykorzystujemy Twoje informacje',
        content: 'Wykorzystujemy zebrane informacje do:',
        items: [
          'Świadczenia, utrzymania i ulepszania naszych usług tworzenia stron internetowych',
          'Komunikacji z Tobą w sprawie projektów, aktualizacji i zapytań',
          'Wysyłania istotnych informacji o naszych usługach (za Twoją zgodą)',
          'Przetwarzania transakcji i wysyłania powiązanych informacji',
          'Analizy użytkowania strony w celu poprawy doświadczenia użytkownika',
          'Wypełniania obowiązków prawnych',
        ],
      },
      protection: {
        title: 'Ochrona danych',
        content:
          'Wdrażamy odpowiednie techniczne i organizacyjne środki bezpieczeństwa w celu ochrony Twoich danych osobowych przed nieautoryzowanym dostępem, zmianą, ujawnieniem lub zniszczeniem. Obejmuje to szyfrowane połączenia (SSL/TLS), bezpieczne przechowywanie plików oraz ograniczony dostęp do danych osobowych tylko dla osób, które tego potrzebują.',
      },
      thirdParty: {
        title: 'Usługi zewnętrzne',
        content:
          'Możemy korzystać z usług zewnętrznych, które zbierają, monitorują i analizują dane w celu ulepszenia naszych usług:',
        items: [
          'Cal.com - Do planowania konsultacji i spotkań',
          'Formspree - Do przetwarzania zgłoszeń z formularza kontaktowego',
          'Narzędzia analityczne - Do zrozumienia ruchu na stronie i wzorców użytkowania',
          'Dostawcy hostingu - Do bezpiecznego i niezawodnego dostarczania naszej strony',
        ],
      },
      clientProjects: {
        title: 'Poufność projektów klientów',
        content:
          'Wszystkie informacje o projektach klientów, w tym strategie biznesowe, materiały brandingowe i treści zastrzeżone, są traktowane jako ściśle poufne. Nie udostępniamy, nie sprzedajemy ani nie ujawniamy szczegółów projektów klientów osobom trzecim bez wyraźnej pisemnej zgody. Pliki projektowe są bezpiecznie przechowywane, a dostęp jest ograniczony do członków zespołu bezpośrednio zaangażowanych w Twój projekt.',
      },
      cookies: {
        title: 'Pliki cookie i śledzenie',
        content:
          'Nasza strona może używać plików cookie i podobnych technologii śledzenia w celu ulepszenia Twojego doświadczenia przeglądania. Możesz ustawić przeglądarkę tak, aby odrzucała pliki cookie, ale niektóre funkcje naszej strony mogą nie działać prawidłowo bez nich. Używamy niezbędnych plików cookie do funkcjonalności strony i możemy używać analitycznych plików cookie, aby zrozumieć, jak odwiedzający korzystają z naszej strony.',
      },
      rights: {
        title: 'Twoje prawa',
        content:
          'W zależności od Twojej lokalizacji możesz mieć określone prawa dotyczące Twoich danych osobowych:',
        items: [
          'Dostęp: Żądanie kopii danych osobowych, które przechowujemy na Twój temat',
          'Korekta: Żądanie poprawienia niedokładnych lub niekompletnych danych',
          'Usunięcie: Żądanie usunięcia Twoich danych osobowych',
          'Sprzeciw: Sprzeciw wobec przetwarzania Twoich danych osobowych',
          'Przenoszenie: Żądanie przeniesienia Twoich danych do innej usługi',
          'Wycofanie zgody: Wycofanie zgody na przetwarzanie danych w dowolnym momencie',
        ],
      },
      contact: {
        title: 'Kontakt',
        content:
          'Jeśli masz pytania dotyczące niniejszej Polityki Prywatności lub chcesz skorzystać ze swoich praw dotyczących danych, skontaktuj się z nami:',
      },
      changes: {
        title: 'Zmiany w tej polityce',
        content:
          'Możemy od czasu do czasu aktualizować niniejszą Politykę Prywatności. Powiadomimy Cię o wszelkich zmianach, publikując nową Politykę Prywatności na tej stronie i aktualizując datę „Ostatnia aktualizacja". Zachęcamy do okresowego przeglądania niniejszej Polityki Prywatności w celu sprawdzenia ewentualnych zmian.',
      },
    },
  },
}
